import { alpha } from '@mui/material';

export default theme => ({
  root: {
    height: 10,
    borderRadius: 5,
    marginLeft: 12,
    marginRight: 12
  },
  colorPrimary: {
    backgroundColor: alpha(theme.palette.info.main, 0.15)
  },
  bar: {
    borderRadius: 5,
    backgroundColor: theme.palette.info.main
  }
});
